document.addEventListener("DOMContentLoaded", function () {
  let isLoading = false;
  let currentPage = 1;
  let loadMoreButton = document.getElementById("load-more-button");

  const productGrid = document.getElementById("product-grid");

  const filterForm = document.getElementById("filter-form");

  function getLoadMoreButton() {
    return document.getElementById("load-more-button");
  }

  function handleLoadMore() {
    loadMoreButton = getLoadMoreButton();
    if (!loadMoreButton || isLoading) return;

    const nextUrl = loadMoreButton.getAttribute("data-next-url");
    if (!nextUrl) return;

    isLoading = true;

    fetch(nextUrl)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newProducts = doc.querySelectorAll('#product-grid .grid__item');
        const newItems = doc.querySelectorAll("#product-grid .grid__item");
        const newButton = doc.querySelector("#load-more-button");

        newItems.forEach((item) => productGrid.appendChild(item));




           
                newProducts.forEach(item => {
                    const cardWrapper = item.querySelector('.card-wrapper');
                    if (cardWrapper) {
                      const variantId = cardWrapper.getAttribute('data-var-id');
                      if (variantId) {
                        // Call the function for each variant
                        alertVariant(variantId, "card", "https://roollapius.korres.com");
                      }
                    }
                  });
        if (loadMoreButton) loadMoreButton.remove();
        if (newButton) productGrid.parentNode.appendChild(newButton);

        isLoading = false;
      })
      .catch((err) => {
        console.error("Load More Error:", err);
        isLoading = false;
      });
  }

  function scrollHandler() {
    const button = getLoadMoreButton();
    if (!button || isLoading) return;

    const rect = button.getBoundingClientRect();
    if (rect.top < window.innerHeight + 100) {
      handleLoadMore();
    }
  }

  // Attach scroll listener
  window.addEventListener("scroll", scrollHandler);

  // Handle Filter AJAX
  if (filterForm) {
    filterForm.addEventListener("change", function (e) {
      e.preventDefault();
      const formData = new FormData(filterForm);
      const params = new URLSearchParams(formData).toString();
      const url = `${window.location.pathname}?${params}`;

      fetch(url)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newGrid = doc.querySelector("#product-grid");
          const newButton = doc.querySelector("#load-more-button");

          if (newGrid) productGrid.innerHTML = newGrid.innerHTML;
          if (loadMoreButton) loadMoreButton.remove();
          if (newButton) productGrid.parentNode.appendChild(newButton);

          currentPage = 1;
          isLoading = false;

          // Trigger scroll check after filter update
          scrollHandler();
        })
        .catch((err) => console.error("Filter Error:", err));
    });
  }
});
